A position opening with the given `id`.
